import * as React from "react";
import {useNavigate} from "react-router-dom";
import {useAuthDispatcher} from "../../../context/AuthContext";
import {actionTypes} from "../../../context/reducer";
import {removeUserRefreshToken, removeUserToken} from "../../../service/localStorage/LocalStorageService";
import {RouteHelper} from "../../../route/RouteHelper";
import logOut from "../../../assets/images/header/10.svg"
import "./Logout.scss"
import {
    DialogSize,
    RaikoButtonPrimary, RaikoButtonSecondary,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";

const LogOut = (
    {
        openDialog,
        handleClickClose
    }) => {


    const navigate = useNavigate()
    const dispatcher = useAuthDispatcher()

    return (
        <RaikoDefaultDialogPage
            onClose={handleClickClose}
            open={openDialog}
            dialogSize={DialogSize.WRAP_CONTENT}
        >
            <RaikoGridOneColumn className={`baseLogoutContainer`}>
                <img src={logOut} alt="logOut"/>

                <span className={"logoutTitle"}>
                            خروج از حساب کاربری
                </span>

                <span
                    className={"logoutSubtitle"}>
                    آیا می خواهید از حساب کاربری خود خارج شوید؟
                </span>
                <div className={"actionButtonContainer"}>
                    <RaikoButtonPrimary
                        className="w-100"
                        label="انصراف"
                        onClick={handleClickClose}
                    />

                    <RaikoButtonSecondary
                        className="w-100"
                        label="خروج"
                        autoFocus
                        onClick={_ => doUserLoginOut(dispatcher, navigate)}
                    />
                </div>
            </RaikoGridOneColumn>
        </RaikoDefaultDialogPage>
    )
}
export default LogOut

export function doUserLoginOut(dispatcher, navigate) {

    dispatcher({
        type: actionTypes.LOGOUT,
        token: null
    })

    removeUserRefreshToken()
    removeUserToken()
    navigate(RouteHelper.SignInEnterPhoneNumber.globalUrl)
}